import React from 'react';
import Modal from '../../../commonComponents/util/Modal';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import WizardStep1 from './WizardStep1';
import WizardStep2 from './WizardStep2';
import WizardStep3 from './WizardStep3';
import { formatDate } from '../../../../lib/utils';
import _cloneDeep from 'lodash.clonedeep';

export default class VerifyListWizardModal extends React.Component {
    constructor(props) {
        super(props);

        this.initialState  = {
            wizardStep: 1,
            newParticipants: [],
            rejectedParticipants: [],
            defaultAmount: ''
        };

        this.state = _cloneDeep(this.initialState);
    }
    
    componentWillReceiveProps(nextProps) {
        if (nextProps.campaignList.defaultAmount && !this.state.defaultAmount) {
            this.setState({ defaultAmount: nextProps.campaignList.defaultAmount });
        }
    }

    onNext() {
        if (this.state.wizardStep < 3) {
            this.setState({
                wizardStep: this.state.wizardStep + 1
            });
        }
    }
    
    onPrevious() {
        if (this.state.wizardStep > 1) {
            this.setState({
                wizardStep: this.state.wizardStep - 1
            });
        }
    }

    onClose() {
        this.setState({...this.initialState, newParticipants:[], rejectedParticipants:[]}, this.props.close);
    }

    updateRejectedParticipants = rejectedParticipants => {
        this.setState({ rejectedParticipants })
     }

    async onSubmit(bypassListError) {
        if (this.state.newParticipants.length < this.props.externalUpdates.data.addedParticipants.length) return;

        let newParticipants = this.state.newParticipants;
        
        await this.props.verifyUpdates(
            this.props.campaign.campaignId,
            this.props.campaignList.campaignListId,
            newParticipants.map(({ key, value }) => ({ key, value })), //dont send in name,
            this.state.rejectedParticipants,
            this.state.defaultAmount,
            bypassListError
        );

        if (this.props.verifyingUpdates.success)
            this.onClose();
    }

    render() {
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal verify-modal xl-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Verify Updated List and Create Applications</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose.bind(this)}></i>
                        </div>
                        <div className="modal-subheader">
                            <div className="flex-center verify-campaign-details-header"> 
                                <h1>{this.props.campaignList.name}</h1>
                                <p className="xs-text accent-text">Submitted by {this.props.campaignList.manager} on {formatDate(this.props.campaignList.submittedDate)}</p>
                            </div>
                            <div className="verify-modal-steps flex-center">
                                {['Review Update', 'Verify New Participants', 'Confirm And Add List To Campaign'].map((step, index) => {
                                    const active = this.state.wizardStep === index + 1;
                                    const completed = this.state.wizardStep > (index + 1);
                                    return <div key={index}>
                                        <div className="flex-center">
                                            {<p className={`step-circle ${active ? "active" : ""} ${completed ? "completed" : ""}`}>
                                                {completed ? <i className="icon ion-checkmark"></i> : index + 1}
                                            </p>}
                                            <p>{step}</p>
                                            {index < 2 && <i className="icon ion-ios-arrow-right accent-text icon-right"></i>}
                                        </div>
                                    </div>
                                })}
                            </div>
                            <hr />
                        </div>

                        {this.props.externalUpdates.loading ? <LoadingSpinner height="30" /> : <div className="verify-modal-body">
                            {this.state.wizardStep === 1 &&
                                <WizardStep1
                                    close={this.onClose.bind(this)}
                                    next={this.onNext.bind(this)}
                                    removedParticipants={this.props.externalUpdates.data.removedParticipants || []}
                                    updatedParticipants={this.props.externalUpdates.data.updatedParticipants || []}
                                    isIsraeli={this.props.campaign.isIsraeli}
                                    isOrgList={this.props.campaignList.isOrgList}
                                />}
                            {this.state.wizardStep === 2 &&
                                <WizardStep2
                                    close={this.onClose.bind(this)}
                                    next={this.onNext.bind(this)}
                                    previous={this.onPrevious.bind(this)}
                                    newParticipants={this.state.newParticipants || []}
                                    rejectedParticipants={this.state.rejectedParticipants || []}
                                    addedParticipants={this.props.externalUpdates.data.addedParticipants || []}
                                    getRecipientSuggestions={this.props.getRecipientSuggestions}
                                    recipientSuggestions={this.props.recipientSuggestions}
                                    getListRecipients={() => this.props.getListRecipients(this.props.campaignList.campaignListId)}
                                    listRecipients={this.props.listRecipients}
                                    updateNewParticipants={newParticipants => this.setState({ newParticipants })}
                                    updateRejectedParticipants={(this.updateRejectedParticipants)}
                                    locationId={this.props.campaign.locationId}
                                    isIsraeli={this.props.campaign.isIsraeli}
                                    isOrgList={this.props.campaignList.isOrgList}
                                />}
                            {this.state.wizardStep === 3 &&
                                <WizardStep3
                                    close={this.onClose.bind(this)}
                                    previous={this.onPrevious.bind(this)}
                                    submit={this.onSubmit.bind(this)}
                                    newParticipants={this.state.newParticipants}
                                    updateNewParticipants={newParticipants => this.setState({ newParticipants })}
                                    updateRejectedParticipants={(this.updateRejectedParticipants)}
                                    rejectedParticipants={this.state.rejectedParticipants}
                                    getReceivingParticipants={(...tableProps) => 
                                        this.props.getReceivingParticipants(this.props.campaignList.campaignListId, this.state.newParticipants, ...tableProps)}
                                    receivingParticipants={this.props.receivingParticipants || []}
                                    clearReceivingParticipants={(this.props.clearReceivingParticipants)}
                                    campaignName={this.props.campaign.name}
                                    defaultAmount={this.state.defaultAmount}
                                    maxAmount={this.props.campaign.isIsraeli ? this.props.campaign.maxAmountShekel : this.props.campaign.maxAmountDollar}
                                    isIsraeli={this.props.campaign.isIsraeli}
                                    updateDefaultAmount={defaultAmount => this.setState({ defaultAmount })}
                                    submitting={this.props.verifyingUpdates.loading}
                                    message={this.props.verifyingUpdates.message}
                                    error={!this.props.verifyingUpdates.loading && !this.props.verifyingUpdates.success}
                                />}
                        </div>}
                        {(!this.props.externalUpdates.loading && !this.props.externalUpdates.success) &&
                            <span className="error-label text-right">Something went wrong and we were unable to retrieve external updates for the {this.props.campaignList.name} campaign list.  Please try again.</span>}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/VerifyCampaignListWizard/VerifyListWizardModal.jsx